export default __webpack_public_path__ + "fonts/icomoon.svg?83e7f711374f5b4915d84a616da7e777";